<!--
 * @Author: Cathy
 * @Date: 2020-02-24 10:00:48
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:41:33
 * @Description: 联吧下载
 -->

<template>

  <div class="download">

    <!-- <topMenu pageType="recommend" /> -->
    <van-nav-bar title="搜索"
                 left-arrow
                 @click-left="onClickLeft" />
    <!-- <van-search v-model="value" placeholder="请输入搜索关键词" /> -->

    <catalogue :list="list"
               v-if="list.length > 0" />
    <div class="input_box">
      <div class="search_box">
        <input class="search"
               type="search"
               placeholder="搜索视频 / 图文教程"
               @keypress="searchGoods"
               v-model="search" />
        <div class="icon"
             @click.stop="searchClick">
          <van-icon name="search"
                    color="#000"
                    size="24" />
        </div>
      </div>
    </div>
    <div class="inner">
      <!-- <div class="tips_box">
        <div @click="goBack(-2)" class="text">联吧相关</div>
        <div class="text" @click="goBack(-1)">>>{{name}}:</div>
         <div class="text">>>{{fullyName}}:</div>
      </div> -->
      <div class="list_box"
           @scroll.passive="scroll($event)"
           v-if="list.length > 0">
        <div class="detail">
          <div class="tItem"
               v-for="(item, index) in list"
               :key="index"
               @click="directionsDetail(item.h5_id,item.type)">
            <img :src="item.type == 1 || item.type == 4 ?item.video_page:item.pt_page" />
            <a :id="'title' + index" />
            <p>{{ index + 1 }}.{{ item.title }}</p>
            <!-- <div v-html="item.content" style="margin-top: 0.4rem"></div> -->
          </div>
        </div>
      </div>
    </div>
    <isWeixinMark :isWeixin="isWeixin"
                  @onCancelMark="isWeixin = false" />
    <div class="downloadImage"
         @click="onDownload">
      <img src="../assets/images/xiazai_duan.png" />
    </div>

  </div>

</template>

<script>
// import topMenu from '../components/topMenu'
import isWeixinMark from '../components/isWeixinMark'
import { getList, getWapSearchList } from '../api/wap'
import catalogue from '../components/catalogue'
export default {
  name: 'download',
  components: {
    // topMenu,
    isWeixinMark,
    catalogue
  },
  data () {
    return {
      downloadLink: '',
      isWeixin: false,
      page: 1,
      page_total: 1,
      list: [],
      search: '',
      key: ''
    }
  },
  created () {
    // console.log(this.id);
    if (this.$route.query.key) this.key = this.$route.query.key
    this.onLoadData()
  },
  activated () {
    if (!this.$route.meta.isUseCache) {
    }
  },
  methods: {
    onLoadData () {
      getList({ type: 1 }).then(res => {
        this.downloadLink = res.result.download_url.android
      })
    },
    onDownload () {
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIos) {
        location.href =
          'https://apps.apple.com/cn/app/%E8%81%94%E5%90%A7/id1404140841'
      }
      if (isAndroid) {
        this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1
        if (!this.isWeixin) {
          location.href = this.downloadLink
        }
      }
    },
    searchClick () {
      getWapSearchList({
        page_now: this.page,
        search_key: this.search,
        get_key: this.key
      }).then(res => {
        if (this.page === 1) {
          this.list = res.result
        } else {
          this.list.push(...res.result)
        }
        this.page_total = res.page_total
      })
    },
    directionsDetail (id, type) {
      this.$route.meta.isUseCache = true
      if (type === 2 || type === '2' || type === 5 || type === '5') {
        this.$router.push({
          path: '/videoDetail',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({
          path: '/directionsDetail',
          query: {
            id: id
          }
        })
      }
    },
    onClickLeft () {
      this.$router.back()
    },
    scroll (e) {
      let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
      if (bottom === 0) {
        if (this.page < this.page_total) {
          this.page++
          this.searchClick()
        }
      }
    },
    searchGoods (e) {
      if (e.keyCode === 13 || e.keyCode === '13') {
        e.preventDefault()
        this.searchClick()
      }
    }
  }
}
</script>

<style scoped>
.downloadImage {
  /* margin-top: 1rem; */
  text-align: center;
  /* position: fixed;
  bottom: 0;
  left: 0; */
  width: 100%;
  padding: 0.2rem 0;
  background: #f3f3f3;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
.download >>> .van-nav-bar .van-icon {
  color: #000;
}
.download {
  height: 100%;
  background-color: #f3f3f3;
  display: flex;
  flex-direction: column;
}
.van-hairline--bottom::after {
  border: none !important;
}
/* .input_box {
  padding: 0.2rem 0.4rem;
}
.search_box {
  width: 100%;
  position: relative;
  height: 0.9rem;
  display: flex;
  align-items: center;
}
.search_box .search {
  height: 100%;
  background: #fff;
  border-radius: 0.05rem;
  border: 1px solid rgba(216, 216, 216, 1);
  width: 100%;
  font-size: 0.28rem;
  padding: 0 0.2rem;
} */
.input_box {
  display: flex;
  align-items: center;
  /* padding-left: 0.2rem; */
  background: #fff;
}
.search_box {
  width: 100%;
  background-color: #fff;
  padding: 0.2rem 0.2rem;
  position: relative;
  height: 1.1rem;
  display: flex;
}
.search {
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 0.3rem;
  font-size: 15px;
  background: #e7e7e7;
  border-radius: 0.35rem;
  border: none !important;
  line-height: 0.3rem;
}
.search_box .icon {
  position: absolute;
  top: 50%;
  right: 0.4rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  background: #fff;
}
.van-icon-search:before {
  background: #e7e7e7;
}
.inner >>> .van-cell {
  align-items: center;
  font-size: 0.28rem !important;
  line-height: 0.4rem;
}
.inner {
  padding-bottom: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.tips_box {
  font-size: 0.28rem;
  line-height: 0.6rem;
  padding-left: 0.2rem;
  display: flex;
  align-items: center;
}
.list_box {
  flex: 1;
  overflow: auto;
}
.text {
  max-width: 2.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.detail {
  padding: 0.3rem 0.1rem 1rem;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
}
.detailItem {
  margin-top: 0.4rem;
  padding: 0.4rem;
  border-radius: 0.16rem;
  box-shadow: 0 0 0.46rem 0 rgba(4, 0, 0, 0.13);
}
.detailItem p {
  color: #121212;
  font-size: 0.34rem;
  font-weight: bold;
}
.tItem {
  /* margin-top: 0.59rem; */
  width: 3.45rem;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
  margin-bottom: 0.5rem;
}
.tItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0.2rem 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
</style>
